import api from './api';

export const getMyClub = () =>
  api.get('/api/clubs/me');

export const updateMyClub = (data) =>
  api.put('/api/clubs/me', data);

// Club-wide settings (Primary Admin only) — e.g. { defaultCalendar: 'ad' | 'bs' }
export const updateClubSettings = (data) =>
  api.patch('/api/clubs/me/settings', data);

export const uploadClubImage = (imageData, purpose) =>
  api.post('/api/clubs/me/upload-image', { imageData, purpose });

export const getMarketingAssets = () =>
  api.get('/api/clubs/me/marketing-assets');

export const getPublicClubProfile = (slug) =>
  api.get(`/api/clubs/public/${slug}`);
